// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"71d91f3b","544":"e5249df8","705":"f733579e"}[chunkId] + ".chunk.js";
};